/** Bosh sahifalar (redesign v2): recruiter -- Today, manager -- Today + Team, owner -- Company pulse. en -- manba */
export default {
  loadError: "Could not load the home page.",
  greeting: { morning: "Good morning, {{name}}", afternoon: "Good afternoon, {{name}}", evening: "Good evening, {{name}}" },
  eyebrow: "{{date}} · Tashkent {{tashkent}} · Dallas {{dallas}}",
  eyebrowShort: "{{date}} · Tashkent {{tashkent}}",
  callOpen: "Dallas {{time}} — call hours, {{left}} left",
  callClosed: "Dallas is {{time}} — call hours open at {{at}}, in {{wait}}",
  overdue_one: "{{count}} overdue",
  overdue_other: "{{count}} overdue",
  nothingOverdue: "nothing overdue",
  addDriver: "Add driver",
  kpi: {
    newDrivers: "New drivers",
    submitted: "Submitted to carriers",
    waiting_one: "{{count}} waiting",
    waiting_other: "{{count}} waiting",
    forReply: "for a carrier reply",
    hired: "Hired",
    pending_one: "{{count}} pending",
    pending_other: "{{count}} pending",
    approved: "approved by manager",
    myBonus: "My bonus",
    estimate: "Estimate",
    finalAfter: "final after approval",
    hires: "Hires",
    inPipeline: "In pipeline",
    submittedN_one: "{{count}} submitted",
    submittedN_other: "{{count}} submitted",
    thisMonth: "this month",
    profit: "Profit",
    noFees: "No fees yet",
    moneyNote: "received {{received}} · cost {{cost}}",
    costPerHire: "Cost per hire",
    costNote: "expenses + salaries + bonuses",
    avgTime: "Avg time to hire",
    retentionChip: "{{pct}} retention",
    retentionNote: "30-day, hires that passed 30 days",
    vs: "vs {{month}}",
    prevIn: "{{count}} in {{month}}",
    noPrev: "no data for {{month}}",
    same: "same as {{month}}",
  },
  today: {
    title: "Today",
    overdue_one: "{{count}} overdue",
    overdue_other: "{{count}} overdue",
    dueToday_one: "{{count}} due today",
    dueToday_other: "{{count}} due today",
    tomorrow_one: "{{count}} tomorrow",
    tomorrow_other: "{{count}} tomorrow",
    all: "All tasks",
    empty: "Nothing due today. Nice.",
    markDone: "Mark done",
    snooze: "Tomorrow 9:00",
    call: "Call",
    yours_one: "your {{count}} driver",
    yours_other: "your {{count}} drivers",
    doneFailed: "Could not mark the task as done",
    snoozed: "Snoozed until tomorrow 9:00",
  },
  due: { yesterday: "Yesterday", today: "Today", tomorrow: "Tomorrow", overdue: "Overdue" },
  attention: {
    trucks: "trucks with insurance or inspection due within {{days}} days",
    title: "Needs attention",
    live: "Live",
    noContact: "no contact for {{days}}+ days",
    waitingDocs: "missing required documents",
    docsExpired: "expired documents",
    cdl: "CDL expires within 30 days",
    cdlOne: "CDL expires in {{days}} days",
    carrier: "carrier replies pending 3+ days",
    stale: "drivers {{days}}+ days in the same stage",
    overdue: "overdue reminders across recruiters",
    quiet: "recruiters quiet {{days}}+ days",
    approvals: "approvals waiting for you",
    allClear: "All clear — nothing needs attention right now.",
    andMore_one: "and {{count}} more",
    andMore_other: "and {{count}} more",
  },
  pipeline: {
    title: "My pipeline",
    branch: "Pipeline",
    active_one: "{{count}} active",
    active_other: "{{count}} active",
    board: "Open board",
    empty: "No active drivers yet.",
  },
  recent: { title: "Recently updated", all: "All drivers", empty: "No drivers yet. Add your first driver." },
  leader: {
    sub: "{{month}} · hires",
    you: "(you)",
    rank: "You are {{pos}} of {{of}}",
    myPage: "My page",
    top: "Top recruiters",
    allPeople: "All people",
    none: "No approved hires yet this month.",
    without_one: "{{count}} recruiter without a hire yet",
    without_other: "{{count}} recruiters without a hire yet",
    hires_one: "{{count}} hire",
    hires_other: "{{count}} hires",
  },
  company: {
    title: "Company pulse",
    line: "Day {{day}} of {{days}} · {{recruiters}} recruiters in {{branches}} branches · {{activities}} activities this week",
    lineBranch: "Day {{day}} of {{days}} · {{recruiters}} recruiters · {{activities}} activities this week",
  },
  branches: {
    title: "Branches",
    compare: "Compare in Reports",
    rowHint: "Row click opens that branch",
    back: "All branches",
    cols: { branch: "Branch", recruiters: "Recruiters", new: "New", submitted: "Submitted", hired: "Hired", retention: "Retention", pipeline: "Pipeline" },
  },
  months: { title: "Hires", sub_one: "last 12 months · {{count}} total", sub_other: "last 12 months · {{count}} total", trends: "Trends" },
  weeks: { title: "Hires per week", sub: "approved · 8 weeks" },
  money: {
    title: "Money",
    sub: "{{month}} · USD",
    finance: "Finance",
    expected: "Expected",
    received: "Received",
    cost: "Cost",
    profit: "Profit",
    noFees_one: "No carrier fee recorded for {{month}}'s {{count}} hire",
    noFees_other: "No carrier fees recorded for {{month}}'s {{count}} hires",
  },
  funnel: { title: "Funnel", sub: "{{month}} · % from previous step", lost_one: "Lost {{count}}", lost_other: "Lost {{count}}" },
  manager: {
    line: "{{scope}} · {{recruiters}} recruiters · {{approvals}} · {{overdue}}",
    approvalsWaiting_one: "{{count}} approval waiting",
    approvalsWaiting_other: "{{count}} approvals waiting",
    tasksOverdue_one: "{{count}} of your tasks overdue",
    tasksOverdue_other: "{{count}} of your tasks overdue",
    teamTitle: "Team today",
    team: "Team",
    teamSub: "{{active}} active now · {{quiet}} quiet this week",
    cols: { recruiter: "Recruiter", callsToday: "Calls today", submitted: "Submitted", hired: "Hired", last: "Last activity" },
    quietDays_one: "Quiet {{count}} day",
    quietDays_other: "Quiet {{count}} days",
    never: "No activity yet",
    more_one: "{{count}} more recruiter",
    more_other: "{{count}} more recruiters",
    showAll: "Show everyone",
    noRecruiters: "No recruiters in this scope yet.",
    approvals: "Approvals",
    waiting_one: "{{count}} waiting",
    waiting_other: "{{count}} waiting",
    reviewAll: "Review all",
    openDriver: "Open driver",
    approve: "Approve",
    reject: "Reject…",
    approved: "Approved: {{name}}",
    approveFailed: "Could not approve",
    noApprovals: "Nothing waiting for your decision.",
    recruiters: "Recruiters",
    recruitersSub: "{{month}} · row opens the person",
    reports: "Reports",
    cols2: { new: "New", contacted: "Contacted", submitted: "Submitted", hired: "Hired", conv: "Conv.", days: "Avg days", recruiters: "Recruiters", retention: "Retention" },
    myDrivers: "My drivers",
  },
};
